import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import httpService from "../../services/httpService";


Footer.propTypes = {

};

function Footer({ shareUrl, shareText }) {
    const [loading, setLoading] = useState(false);

    const handleEmailSubscription = async (e) => {
        e.preventDefault();

        const email = e.target["subscribe-email"].value;

        try {
            setLoading(true);

            const res = await httpService.post(`subscription/newsletter-subscription?email=${email.trim()}`);

            if (res.status === 201) {
                alert("Subscribed successfully!");
                e.target.reset();
            }
        } catch (err) {
            alert("Subscription could not be completed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className="footer">
            <div className="top-footer">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4">
                            <div className="footer-logo">
                                <img src={require('../../assets/images/logo.png')} alt="images" />
                            </div>
                            <p className='text-dark'>Trusted and Leading Source for UK immigration updates</p>
                        </div>
                        <div className="col-lg-9 col-md-8">
                            <div className="wd-social d-flex aln-center">
                                <span>Follow Us:</span>
                                <ul className="list-social d-flex aln-center">

                                    <li><Link to="https://www.facebook.com/profile.php?id=61587216466717"><i className="icon-facebook"></i></Link></li>
                                    <li><Link to="https://www.linkedin.com/company/united-kingdom-immigration-council-news-ukicnews"><i className="icon-linkedin2"></i></Link></li>
                                    <li><Link to="https://x.com/ukicnews173216"><i className="icon-twitter"></i></Link></li>
                                    <li><Link to="https://www.instagram.com/ukicnews/"><i className="icon-instagram1"></i></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="inner-footer">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <div className="footer-cl-1">

                                <div className="ft-icon">Recieve breaking immigration news as soon as it happens. Subscribe to our newsletter.</div>
                                <form id="subscribe-form" onSubmit={handleEmailSubscription}>
                                    <input type="email" placeholder="enter your email address" required={true} id="subscribe-email" />
                                    <button className="tf-button" type="submit" disabled={loading}>
                                        {loading ? "..." : <i className="icon-paper-plane-o"></i>}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-6">
                            <div className="footer-cl-2">
                                <h6 className="ft-title">
                                    Topics
                                </h6>
                                <ul className="navigation-menu-footer">
                                    <li> <Link to="/jobs">Sponsorship Jobs</Link> </li>
                                    <li> <Link to="/news/category/community">International Community</Link> </li>
                                    <li> <Link to="/news/category/family-sponsorship">Family Sponsorship</Link> </li>
                                    <li> <Link to="/news/category/work">Work</Link> </li>
                                    <li> <Link to="/news/category/citizenship">Citizenship</Link> </li>
                                    <li> <Link to="/news/category/study">Study</Link> </li>
                                    <li> <Link to="/news/category/visit">Visit</Link> </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-6">
                            <div className="footer-cl-3">
                                <h6 className="ft-title">
                                    Who we are
                                </h6>
                                <ul className="navigation-menu-footer">
                                    <li> <Link to="/about-us">About us</Link> </li>
                                    <li> <Link to="/#">Our Standards</Link> </li>
                                </ul>
                                <br />
                                <h6 className="ft-title">
                                    Media Partners
                                </h6>
                                <ul className="navigation-menu-footer">
                                    <li> <Link to="#">Meet our partners</Link> </li>
                                    <li> <Link to="#">Advertise with us</Link> </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-6">
                            <div className="footer-cl-4">
                                <h6 className="ft-title">
                                    Contact Us
                                </h6>
                                <ul className="navigation-menu-footer">
                                    <li className='text-dark'>customer@ukicnews.com</li>
                                    <li></li>
                                    <li><p className='text-dark'>Greater Cardiff Area, Wales, UK</p></li>

                                </ul>
                            </div>
                        </div>
                        {/* <div className="col-lg-2 col-md-4 col-6">
                            <div className="footer-cl-5">
                                <h6 className="ft-title">
                                    Download App
                                </h6>
                                <ul className="ft-download">
                                    <li> <Link to="#"><img src={require('../../assets/images/review/btn3.png')} alt="images" /></Link></li>
                                    <li> <Link to="#"><img src={require('../../assets/images/review/btn4.png')} alt="images" /></Link></li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="bottom">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="bt-left">
                                <div className="copyright">©UKICNEWS. All Rights Reserved.</div>
                                <div className="select-language">
                                    <div className="dropdown" id="language">
                                        <a className="btn-selector nolink input-form"><span><img src={require('../../assets/images/review/flag.png')} alt="" /></span>
                                            English</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <ul className="menu-bottom d-flex aln-center">
                                <li><Link to="privacy">Privacy Policy</Link> </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;